module.exports = __webpack_public_path__ + "static/media/main-mobile.8ed0f6bf.jpeg";